import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

interface ErrorDialogState {
  message: string | null;
  title: string | null;
}

const initialState: ErrorDialogState = {
  message: null,
  title: null
};

const errorDialogSlice = createSlice({
  name: 'errorDialog',
  initialState,
  reducers: {
    showError(state, action: PayloadAction<{ message: string; title?: string }>) {
      state.message = action.payload.message;
      state.title = action.payload.title ?? null;
    },
    dismissError(state) {
      state.message = null;
      state.title = null;
    }
  }
});

export const { showError, dismissError } = errorDialogSlice.actions;

export const selectErrorDialog = (state: RootState) => state.errorDialogSlice;

export default errorDialogSlice.reducer;
